module.exports = __webpack_public_path__ + "img/starry_oops.3f17b35d.png";